import { Box, Typography, useTheme, Chip } from '@mui/material';

export interface SectionTitleProps {
  icon?: string;
  title: string;
  tags?: string[];
}

export const SectionTitle = ({ icon = '', title = '', tags }: SectionTitleProps) => {
  const theme = useTheme();
  return (
    <>
      {icon && <Box component="img" src={icon} />}
      <Typography color={theme.palette.grey[900]} variant="subtitle1">
        {title}
      </Typography>
      {tags?.map((tag) => <Chip sx={{ borderRadius: 0.75 }} label={tag} color="default" size="small" variant="outlined" />)}
    </>
  );
};
